import isEqual from 'lodash-es/isEqual';
import React from 'react';

export function useDocAnchorHeadingList(docContentRef: React.RefObject<HTMLDivElement>) {
  const [headingList, setHeadingList] = React.useState<
    { id: string; depth: number; text: string }[]
  >([]);

  const minDepth = React.useMemo(() => {
    const list = [...headingList].sort((a, b) => {
      if (a.depth && b.depth) {
        return a.depth - b.depth;
      }
      return 0;
    });
    const firstItem = list[0];
    if (!firstItem) {
      return 0;
    }
    return firstItem.depth;
  }, [headingList]);

  React.useEffect(() => {
    const docContentDom = docContentRef.current;
    if (!docContentDom) {
      return () => {};
    }

    const callback = () => {
      const markdownBody = docContentDom.querySelector('.markdown-body');
      if (!markdownBody) {
        return;
      }

      const nextArray = Array.from(markdownBody.querySelectorAll('h1, h2, h3, h4, h5, h6'))
        .filter((el) => el.id)
        .map((el) => {
          return {
            id: el.id,
            depth: Number(el.tagName.replace('H', '')),
            text: (() => {
              const text = el.textContent ?? '';
              if (text.endsWith('#')) {
                return text.slice(0, -1);
              }
              return text;
            })(),
          };
        })
        .filter((el) => el.text);

      setHeadingList((originValue) => {
        if (isEqual(originValue, nextArray)) {
          return originValue;
        }
        return nextArray;
      });
    };

    const observer = new MutationObserver(callback);
    observer.observe(docContentDom, {
      childList: true,
      subtree: true,
    });
    callback();
    return () => {
      observer.disconnect();
    };
  }, [docContentRef]);

  return {
    headingList,
    minDepth,
  };
}
